import { ReduxProductAccessProvider } from "./product-access/ProductAccessContext";
import "core-js/es6/string";
import "core-js/es6/array";
import "core-js/es6/map";
import "core-js/es6/set";
import "core-js/es6/object";
import "core-js/es6/promise";
import "core-js/es7/object";
import "core-js/es7/array";
import "raf/polyfill";

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import { TierAccessProvider } from "./contexts/TierAccessContext";

import { i18nReady } from "./i18n";
import { initSentry, SentryErrorBoundary } from "./utils/observability/sentry";

import configureStore from "./store/store";
import { installDialogAriaHiddenGuard } from "./utils/a11y/dialogAriaHiddenGuard";
import { pwaInstallController } from "./pwa/createInstallController";
import { attachManifestPermanently } from "./pwa/manifestLink";
import { isStandaloneApp } from "./pwa/browserDisplayMode";

// Avant le store et le premier rendu : une erreur au démarrage doit déjà remonter.
// N'envoie rien hors des builds prod et staging (cf. utils/observability/sentry.js).
initSentry();

const store = configureStore();

// Avant tout rendu : une fenetre mal fermee laisse `aria-hidden` sur la racine
// (page invisible au lecteur d'ecran) et le verrouillage du defilement
// (page figee pour tout le monde) — cf. dialogAriaHiddenGuard.js.
installDialogAriaHiddenGuard();
// Retain installation capability even when the user starts in the classic UI.
pwaInstallController.start();
// Le manifeste n'est déclaré qu'en Nouvelle interface (pwa/manifestLink.js), sauf dans
// l'application installée, qui en a besoin partout pour ses mises à jour.
if (isStandaloneApp()) attachManifestPermanently();

const container = document.getElementById("app");
const root = createRoot(container);
// Le dictionnaire de la langue initiale est un chunk separe (cf. src/i18n.js) :
// on attend qu'il soit disponible pour ne jamais afficher de cles brutes.
i18nReady.then(() =>
  root.render(
    <SentryErrorBoundary>
      <Provider store={store}>
        <ReduxProductAccessProvider><TierAccessProvider>
          <App />
        </TierAccessProvider></ReduxProductAccessProvider>
      </Provider>
    </SentryErrorBoundary>
  )
);
